import React from 'react'

function MenuItem(props) {
    return (
      <div className="col-lg-6 menu-item">
        <div className="menu-content2">
          {props.name}<span>€ {props.price}</span>                   
        </div>
        <div className="menu-ingredients2">
          {props.desc}
        </div>
        <hr></hr>
      </div>      
    )
}

export default MenuItem
